import type { FC } from "react";
import { useState } from "react";

import clsx from "clsx";

import { sendTelemetryEvent } from "@/lib/telemetry";
import { useViewportInfoContext } from "@/src/contexts";
import { TelemetryEntity } from "@Components/Modules/Helpers";

import { ArrowRoundLink } from "../../common/links/ArrowRoundLink";
import { SvgAppearance } from "../../common/links/SvgIconLink";

import * as css from "./CashbackDropDownList.module.css";

export interface IFilterDropDownList<T extends string | number> {
    optionList: FilterDropDownListItem[];
    optionStart: T;
    onChange?: (str: T) => void;
}

export interface FilterDropDownListItem {
    key: string;
    value: string;
}

const CashbackDropDownList: FC<IFilterDropDownList<string>> = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const activeOption = props.optionList?.find((x) => x.key === props.optionStart) || props.optionList[0];
    const [option, setOption] = useState(activeOption);

    const { isMobileOrTablet } = useViewportInfoContext();

    const toggleList = () => setIsOpen(!isOpen);

    const itemClick = (obj: FilterDropDownListItem) => {
        setOption(obj);
        setIsOpen(false);

        sendTelemetryEvent({
            eventName: `${TelemetryEntity.Cashback}-SortingEdit`,
            actionType: "Click",
            param1: obj.key,
        });

        if (props.onChange) {
            props.onChange(obj.key);
        }
    };

    const renderListItems = () =>
        props.optionList
            .filter((x) => x.key !== option.key)
            .map((obj) => (
                <li
                    key={obj.key}
                    className={css.filterItem}
                    tabIndex={0}
                    role="menuitem"
                    onClick={() => itemClick(obj)}
                    onKeyUp={() => itemClick(obj)}
                >
                    <span>{obj.value}</span>
                </li>
            ));

    const handleOptionListState = (value: boolean) => isMobileOrTablet === value && toggleList();

    return (
        <div className={css.cashbackDropDownListComponent}>
            <div
                className={css.listWrapper}
                onMouseEnter={() => handleOptionListState(false)}
                onMouseLeave={() => handleOptionListState(false)}
            >
                <div className={css.title} onTouchStart={() => handleOptionListState(true)}>
                    <span>{option.value}</span>
                    <ArrowRoundLink svgAppearance={SvgAppearance.Magenta} eventBubbling={true} />
                </div>
                <ul className={clsx(isOpen && css.opened)}>{isOpen && renderListItems()}</ul>
            </div>
        </div>
    );
};

export default CashbackDropDownList;
